import React, {useState, useEffect, useRef} from 'react'

const ContentEditable = ({html, onChange, style}) => {
  const ref = useRef(null);
  const lastHtml = useRef('');

  const emitChange = () => {
    const curHtml = ref.current?ref.current.innerHTML:'';
    if (curHtml !== lastHtml.current) {
      onChange(curHtml);
    }
    lastHtml.current = html;
  };

  useEffect(() => {
    if (!ref.current) return;
    if (ref.current.innerHTML === html) return;

    ref.current.innerHTML = html;
  }, [html]);

  useEffect(() => {
    if(ref.current){
        ref.current.addEventListener('paste', function (e) {
            e.preventDefault()
            var text = e.clipboardData.getData('text/plain')
            document.execCommand('insertText', false, text)
        })
    }
  }, [ref.current]);

  return (
    <div
      style={style}
      onInput={emitChange}
      contentEditable
      ref={ref}
    ></div>
  );
};

export const Title = (props) => {
    //const [content, setContent] = useState('');
    const textareaRef = useRef(null);
    const [height, setHeight] = useState(0);

    let content = props.payload?props.payload:'';

    useEffect(() => {
        if(textareaRef.current !== null){
            //textareaRef.current.style.height = "0px";



            /*const scrollHeight = textareaRef.current.scrollHeight;

            console.log('Scroll height', scrollHeight);
            setHeight(height + scrollHeight);*/
            textareaRef.current.style.height = "0px";
            const scrollHeight = textareaRef.current.scrollHeight;
            textareaRef.current.style.height = scrollHeight + "px";
        }
    }, [content, textareaRef.current]);

/*
    <div style={{
                minHeight: '2em',
                outline: 'none',
                lineHeight: 'normal'
            }} contentEditable={true} html={content} onInput={e => props.onChange(e.currentTarget.textContent)}>{content}</div>*/

    return (
        <div style={{
            fontSize: '3em',
            fontWeight: 'bold'
        }}>
            <div style={{
                color: '#DDDDDD',
                position: 'absolute',
                pointerEvents: 'none',
                lineHeight: 'normal',
                display: content.length?'none':'block'
            }}>Überschrift</div>
            <textarea ref={textareaRef} style={{
               border: 'none',
               outline: 'none',
               height: height + 'px'
            }} value={content} onChange={e=>{
                props.onChange(e.target.value);
            }}></textarea>
            {
                false?
                props.readonly?
                    <div style={{
                        
                        minHeight: '2em',
                        outline: 'none',
                        lineHeight: 'normal'
                    }}>{content}</div>
                :
                    <ContentEditable style={{
                        minHeight: '2em',
                        outline: 'none',
                        lineHeight: 'normal'
                    }} html={content} onChange={(v) => props.onChange(v)} />
                :null
            }
        </div>
    )
}